import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

/**
 * Commponent for accordion tables
 */
@Component({
  selector: '[app-accordion-table]',
  templateUrl: './accordion-table.component.html',
})
export class AccordionTableComponent implements OnInit, OnDestroy, OnChanges {
  @Input() public tableOpened: boolean = true;
  @Input() public accordionHeading: string = 'Title';
  @Input() public isPanelOpened: boolean = true;

  @Input() public actionButtonTooltip: string = null;
  @Input() public actionButtonIcon: string = null;
  @Input() public actionButtonIsDisabled: boolean = false;
  @Input() public actionButtons: Array<any> = [];
  @Input() public spinnerName: string;

  @Output() public actionButtonClickEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() public rowClickEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() public rowButtonClickEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() public panelTriggerClickEvent: EventEmitter<any> = new EventEmitter<any>();

  @Input() public emptyStateIcon: string;
  @Input() public emptyStateText: string;
  @Input() public emptyStateButtonText: string = null;

  @Input() public columns: Array<string>;
  @Input() public keys: Array<string> | any;
  @Input() public data: Array<any> = [];

  @Input() public limitDisplayResults: number = null;
  @Input() public totalData: number = null;
  @Input() public showAllLink: string = null;

  constructor() { }

  public ngOnInit(): void {
    if (this.showAllLink && this.limitDisplayResults === null) {
      this.limitDisplayResults = 5;
    }
  }

  public ngOnDestroy(): void { }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.data?.currentValue?.length && this.showAllLink && this.totalData === null) {
      this.totalData = this.data?.length;
    }
  }

  /**
   * This event fires after the button was clicked
   */
  public actionButtonClick(): void {
    this.actionButtonClickEvent.emit('click');
  }

  /**
   * This event fires after the button was clicked
   */
  public rowClick(element: any): void {
    this.rowClickEvent.emit(element);
  }

  /**
   * Triggers when row button is clicked
   */
  public rowButtonClick(element: any): void {
    this.rowButtonClickEvent.emit(element);
  }

  /**
   * Triggers when the panel trigger is clicked
   */
  public panelTriggerClick(element: any): void {
    this.panelTriggerClickEvent.emit(element);
  }

}
